import * as routes from '@educabot/educablocks-cosmos';
import { MODEL_TYPES } from '@utils/hooks/machineLearning/params';

const kitOptions = [
  {
    id: 1,
    name: 'creabots.tutorials.initiation.name',
    kitName: 'Creabots',
    imageUrl: `${routes.bloquesUri}/images/creabots/initiation/packaging.png`,
    isDisabled: false,
  },
  {
    id: 2,
    name: 'creabots.tutorials.automation.name',
    kitName: 'Creabots',
    imageUrl: `${routes.bloquesUri}/images/creabots/automation/packaging.png`,
    isDisabled: false,
  },
  {
    id: 3,
    name: 'creabots.tutorials.driving.name',
    kitName: 'Creabots',
    imageUrl: `${routes.bloquesUri}/images/creabots/driving/packaging.png`,
    isDisabled: false,
  },
  {
    id: 4,
    name: 'creabots.tutorials.ai.name',
    kitName: 'Creabots',
    imageUrl: `${routes.bloquesUri}/images/creabots/ai/packaging.png`,
    isDisabled: false,
    iaModels: [
      {
        id: 41,
        model: MODEL_TYPES.HANDS,
        name: `projectSelectionModal.label.${MODEL_TYPES.HANDS}`,
        kitName: 'Creabots',
        imageUrl: 'https://storage.googleapis.com/educabot-aec-cdn-1/train/images/hand_gesture.png',
        isDisabled: false,
      },
      {
        id: 42,
        model: MODEL_TYPES.IMAGES,
        name: `projectSelectionModal.label.${MODEL_TYPES.IMAGES}`,
        kitName: 'Creabots',
        imageUrl: 'https://storage.googleapis.com/educabot-aec-cdn-1/train/images/image_classification.png',
        isDisabled: false,
      },
      {
        id: 43,
        model: MODEL_TYPES.SOUNDS,
        name: `projectSelectionModal.label.${MODEL_TYPES.SOUNDS}`,
        kitName: 'Creabots',
        imageUrl: 'https://storage.googleapis.com/educabot-aec-cdn-1/train/images/sounds_classification.png',
        isDisabled: true,
      },
      {
        id: 44,
        model: MODEL_TYPES.FACES,
        name: `projectSelectionModal.label.${MODEL_TYPES.FACES}`,
        kitName: 'Creabots',
        imageUrl: 'https://storage.googleapis.com/educabot-aec-cdn-1/train/images/face_detection.png',
        isDisabled: true,
      },
      {
        id: 45,
        model: MODEL_TYPES.TEXTS,
        name: `projectSelectionModal.label.${MODEL_TYPES.TEXTS}`,
        kitName: 'Creabots',
        imageUrl: 'https://storage.googleapis.com/educabot-aec-cdn-1/train/images/textss_classification.png',
        isDisabled: true,
      },
      {
        id: 46,
        model: MODEL_TYPES.POSES,
        name: `projectSelectionModal.label.${MODEL_TYPES.POSES}`,
        kitName: 'Creabots',
        imageUrl: 'https://storage.googleapis.com/educabot-aec-cdn-1/train/images/body_gesture.png',
        isDisabled: false,
      },
    ],
  },
];

export default kitOptions;
